{
    "notes__delete_confirmation__title": "Interaktion löschen",
    "notes__delete_confirmation__description": "Die Interaktion wird endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    "notes__form_create_title": "Interaktion festhalten",
    "notes__form_create_toast__success_title": "Interaktion erfolgreich erstellt",
    "notes__tasks_section_title": "Aufgaben",
    "notes__tasks_assignee_me": "Ich",
    "notes__tasks_quick_action_call": "Anrufen",
    "notes__tasks_quick_action_clarify_price": "Preis klären",
    "notes__tasks_quick_action_task": "Aufgabe",
    "notes__tasks_summary_open": "offen",
    "notes__tasks_summary_completed": "erledigt",
    "notes__offers_section_title": "Offene Angebote",
    "notes__offers_section_empty": "Keine offenen Angebote",
    "notes__offers_section_summary_one": "{{count}} offen · {{total}}",
    "notes__offers_section_summary_other": "{{count}} offen · {{total}}",
    "notes__offers_section_loading": "Angebote werden geladen…",
    "notes__offers_draft_title": "Entwurf",
    "notes__offers_draft_state": "Entwurf",
    "notes__ai_insights_section_title": "Vertriebsempfehlungen",
    "notes__ai_insights_section_empty": "Keine Vertriebsempfehlungen",
    "notes__ai_insights_section_loading": "Empfehlungen werden geladen…",
    "notes__ai_insights_show_more_one": "{{count}} weitere",
    "notes__ai_insights_show_more_other": "{{count}} weitere",
    "notes__ai_insights_more_articles_one": "{{count}} weiterer Artikel",
    "notes__ai_insights_more_articles_other": "{{count}} weitere Artikel",
    "notes__ai_insights_outcome_action": "Antwort hinzufügen",
    "notes__ai_insights_outcome_none": "Keine",
    "notes__offers_quote_title": "Angebot {{displayId}}",
    "notes__offers_positions_count_one": "{{count}} Position",
    "notes__offers_positions_count_other": "{{count}} Positionen",
    "notes__offers_positions_more_one": "{{count}} weitere Position",
    "notes__offers_positions_more_other": "{{count}} weitere Positionen",
    "notes__offers_margin_label": "DB",
    "notes__offers_kommission": "Komm. {{number}}",
    "notes__offers_task_action": "Aufgabe",
    "notes__offers_confirm_suggestion": "Erledigt markieren",
    "notes__offers_lost_suggestion": "Verloren markieren",
    "notes__offers_confirm_task": "{{offer}} als erledigt markieren",
    "notes__offers_lost_task": "{{offer}} als verloren markieren",
    "notes__form_edit_title": "Interaktion bearbeiten",
    "notes__form_edit_save": "Speichern",
    "notes__form__follow_ups_title": "Aktivitäten",
    "notes__form_edit_toast__success_title": "Interaktion erfolgreich aktualisiert",
    "notes__delete_confirmation__toast__success_title": "Interaktion gelöscht",
    "notes__delete_confirmation__toast__success_description": "Die Interaktion wurde erfolgreich gelöscht",
    "notes__type__visit": "Protokoll",
    "notes__type__visit_not_reached": "Besuch, nicht angetroffen",
    "notes__type__phone_call": "Anruf",
    "notes__type__phone_call_not_reached": "Anruf, nicht angetroffen",
    "notes__type__note": "Notiz",
    "notes__not_reached__active_label": "Nicht angetroffen",
    "notes__not_reached__back": "Zurück",
    "notes__not_reached__reason_placeholder": "Grund (optional)",
    "notes__not_reached__submit": "Nicht angetroffen speichern",
    "notes__placeholder__event": "Wie ist es gelaufen? Was wurde besprochen?",
    "notes__placeholder__phone_call": "Anruf festhalten…",
    "notes__placeholder__note": "Notiz festhalten…",
    "notes__form__customer_label": "Kunde",
    "notes__form__event_label": "Termin",
    "notes__form__agenda_label": "Agenda",
    "notes__form__date_label": "Datum",
    "notes__form__time_label": "Uhrzeit",
    "notes__form__date_prefill_source": "Basierend auf letztem Termin",
    "notes__form__last_event": "Letzter Termin",
    "notes__form__date_now": "Jetzt",
    "notes__form__date_clear": "Datum entfernen",
    "notes__form__protokoll_label": "Protokoll",
    "notes__pin_note": "Notiz anheften",
    "notes__pinned_label": "Angeheftet",
    "notes__pin_success_toast": "Notiz erfolgreich angeheftet",
    "notes__unpin_success_toast": "Notiz erfolgreich abgelöst",
    "notes__pin_confirmation_title": "Notiz bereits angeheftet",
    "notes__pin_confirmation_description": "Es kann immer nur eine Notiz angeheftet sein. Möchtest du stattdessen diese Notiz anheften?",
    "notes__pin_confirmation_cancel": "Abbrechen",
    "notes__pin_confirmation_confirm": "Notiz anheften"
}
